
export default function parseItemNo(itemNo) {
  return itemNo && Number(itemNo).toLocaleString('en-US', { style: 'decimal', minimumIntegerDigits: 8, useGrouping: false });
}
